<template>
    <v-container class="container" fluid>
        <v-data-table
            :headers="header"
            :items="crendential"
            item-key="id"
            :search="search"
            class="elevation-10 ml-2"
            dense
            loading="dataLoading"
            loading-text="Loading... Please wait"
            fixed-header
            height="650px"
        >
            <template v-slot:top>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text"
                        >Credential Types</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        append-icon="mdi-magnify"
                        dense
                    >
                    </v-text-field>
                    <v-spacer />
                    <v-btn
                        class="ml-1"
                        fab
                        large
                        color="secondary"
                        icon
                        @click="$store.state.CredentialType.create = true"
                        exact
                    >
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mx-3" @click="edit(item)"
                    >mdi-pencil</v-icon
                >
                <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </v-data-table>
        <credentialForm
            v-if="$store.state.CredentialType.create"
        ></credentialForm>
        <editCredential
            v-if="$store.state.CredentialType.edit"
            :data="dataEdt"
        ></editCredential>
    </v-container>
</template>

<script>
import credentialForm from '../Modals/Catalogs/CredentialType/Create.vue';
import editCredential from '../Modals/Catalogs/CredentialType/Edit.vue';
import axios from 'axios';
export default {
    components: {
        credentialForm,
        editCredential
    },
    data: function() {
        return {
            header: [
                { text: 'ID', value: 'CredTypeID' },
                {
                    text: 'Credential Type',
                    value: 'CredType'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false
                }
            ],
            dataEdt: [],
            crendential: [],
            dialog: false,
            search: '',
            id: ''
        };
    },
    watch: {
        '$store.state.CredentialType.watch': function() {
            if (this.$store.state.CredentialType.watch == true) {
                this.loadCredentialType();
                this.$store.state.CredentialType.watch = false;
            }
        }
    },
    mounted() {
        this.loadCredentialType();
    },
    methods: {
        edit: function(item) {
            this.dataEdt = item;
            this.$store.state.CredentialType.edit = true;
        },
        loadCredentialType: function() {
            console.log('loadOrders');
            axios
                .get('credential-types')
                .then(response => {
                    this.crendential = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style></style>
